import { Base } from "../../framework/base";
import { IListItems, ListItems } from "../../framework/listItems";
import { IUserGroupListItem, UserGroupListItem } from "./userGroupListItem";

export interface IUserGroupListItems extends IListItems<IUserGroupListItem> {}

export class UserGroupListItems extends ListItems<UserGroupListItem> implements IUserGroupListItems {
    constructor();
    constructor(obj: IUserGroupListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, UserGroupListItem);
    }
}